import { render, staticRenderFns } from "./DiscountRulePreview.vue?vue&type=template&id=32fdd63e&scoped=true&"
import script from "./DiscountRulePreview.vue?vue&type=script&lang=js&"
export * from "./DiscountRulePreview.vue?vue&type=script&lang=js&"
import style0 from "./DiscountRulePreview.vue?vue&type=style&index=0&id=32fdd63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fdd63e",
  null
  
)

export default component.exports